import {ManagedModelType} from 'models/ManagedModelDefinitions';
import {ModelManager} from 'models/managers/ModelManager';
import {getStore} from 'redux-stores/Store';
import {RequestModelSelector} from 'requests/inputs/reduceInputs';
import {openRequest} from 'requests/RequestReduxActions';

import {Request} from '../RequestConstants';

export default class RequestModelManager extends ModelManager<ManagedModelType.REQUEST_BY_ID> {
  constructor() {
    super(ManagedModelType.REQUEST_BY_ID);
  }

  async doFetchMulti(keys: Array<string>): Promise<void> {
    // TODO: implement bulk fetching for requests
    const promises = [];
    for (const key of keys) {
      promises.push(getStore().dispatch(openRequest(key)));
    }
    await Promise.all(promises);
  }

  getModel(modelKey: string): Request | null {
    return new RequestModelSelector(getStore().getState()).getRequest(modelKey);
  }
}
